(function () {
  'use strict';

  angular.module('app').component('versioningPage', versioningListCtrl());

  function versioningListCtrl() {
    return {
      bindings: {},
      controller: VersioningListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/versioning/versioning-page.component.html',
    };
  }

  VersioningListCtrl.$inject = [
    'UtilService',
    'AbilityService',
    'VersioningService',
    'LanguageService',
  ];

  function VersioningListCtrl(UtilService, AbilityService, VersioningService, LanguageService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_versioning_superadmin'),
    };

    // Methods
    vm.createAppVersion = createAppVersion;
    vm.onShowAppVersion = onShowAppVersion;

    // Initializers
    getAppVersions('');
    getAdditionalLanguages();

    function getAppVersions(selectedItem) {
      vm.loadingItems = true;
      VersioningService.getAppVersions().then(function (data) {
        vm.appVersions = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        if (selectedItem) {
          vm.UtilService.itemListChanged(selectedItem.id);
        }
      });
    }

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ get: 'active', skip_check_role: true }).then(function (data) {
        vm.additionalLanguages = data.items;
      });
    }

    function createAppVersion() {
      if (!vm.permissions.canCreate) {
        return;
      }

      var currentAppVersion = vm.UtilService.findItemInArray(vm.appVersions, 'is_current', true);

      VersioningService.openAppVersionModal(
        {},
        vm.additionalLanguages,
        'create',
        getAppVersions,
        currentAppVersion
      );
    }

    function onShowAppVersion(appVersion, mode) {
      VersioningService.openAppVersionModal(appVersion, vm.additionalLanguages, mode);
    }
  }
})();
